/** Static data extraction **/

import { getElementData, PRODUCT_KEYS as S } from "./data_helpers.js";
import { reduceToObject } from "./shared.js";

let staticData = getElementData("#app_data", "data");

window.dbgData = staticData;

/** Dynamic app state handling **/

import { combineReducers, createStore } from "redux";

let [store, dispatchers] = ((defaultSlug) => {
  const UPDATE_QUERY = "UPDATE_QUERY";

  function searchQuery(state = "", action) {
    switch (action.type) {
      case UPDATE_QUERY:
        return action.payload;
      default:
        return state;
    }
  }

  return [
    createStore(combineReducers({ searchQuery })),
    (dispatch) => ({
      updateQuery: (s) => dispatch({ type: UPDATE_QUERY, payload: s }),
    }),
  ];
})();

/** Derived display state **/

import {
  createSelector,
  createStructuredSelector as combineSelectors,
} from "reselect";

let derivedProps = ((staticData) => {
  const _staticDataSelector = (_state) => staticData;

  const searchQuery = (state) => state.searchQuery;
  const levelLabels = createSelector(
    _staticDataSelector,
    (d) => d.level_labels,
  );
  const rankLabels = createSelector(_staticDataSelector, (d) =>
    reduceToObject(d.survey_ranks, (d) => [d.code, d.overall_long_label]),
  );

  let _includes = (str, q) => str.toLowerCase().indexOf(q.toLowerCase()) !== -1;

  const survey = createSelector(_staticDataSelector, (d) => d.survey);

  const schools = createSelector(_staticDataSelector, searchQuery, (sd, q) => {
    return sd.schools.filter((d) =>
      q ? _includes(d.name, q) || _includes(d.full_address, q) : true,
    );
  });
  const groups = createSelector(_staticDataSelector, searchQuery, (sd, q) => {
    return sd.groups.filter((d) => (q ? _includes(d.name, q) : true));
  });

  return combineSelectors({
    searchQuery,
    levelLabels,
    rankLabels,
    survey,
    schools,
    groups,
  });
})(staticData);

/** Components and rendering **/

import React from "react";
import { render } from "react-dom";
import { connect } from "react-redux";
import { Tabs, Tab } from "react-bootstrap";

let TargetCell = ({ target: t, rankDisplay, rankLabels = null }) =>
  t.url ? (
    <td>
      {rankDisplay ? (
        <span
          className={`summary-well rank-${t.rank}-cell`}
          title={`Overall: ${rankLabels[t.rank]}`}
        />
      ) : null}
      <a href={t.url}>{t.name}</a>
      {t.full_address ? (
        <span className="address">{t.full_address}</span>
      ) : null}
    </td>
  ) : (
    <td>
      <span className="summary-well not-viewable">
        <span className="glyphicon glyphicon-lock" title="Not viewable" />
      </span>
      <a>{t.name}</a>
      {t.full_address ? (
        <span className="address">{t.full_address}</span>
      ) : null}
    </td>
  );

let SchoolsPanel = ({
  survey,
  schools,
  rankLabels,
  levelLabels,
  searchQuery,
  updateQuery,
}) => (
  <div>
    <input
      type="search"
      placeholder={
        survey.product_key === S.BEL4T
          ? "Find Teacher by Name, School, Address or Zip"
          : "Find School by Name, Address or Zip"
      }
      value={searchQuery}
      onChange={(evt) => updateQuery(evt.target.value)}
    />
    <table className="table no-select">
      <thead>
        <tr>
          {survey.product_key === S.BEL4T ? (
            <th>Teacher Name</th>
          ) : (
            <th>School Name</th>
          )}
          <th>School Type</th>
        </tr>
      </thead>
      <tbody>
        {schools.length ? (
          schools.map((t) => (
            <tr key={t.slug}>
              <TargetCell
                target={t}
                rankDisplay={survey.is_5e_shaped}
                rankLabels={rankLabels}
              />
              <td>{levelLabels[t.level]}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="2">No schools available.</td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

let GroupsPanel = ({ survey, groups, searchQuery, updateQuery }) => (
  <div>
    <input
      type="search"
      placeholder="Find Group by Name"
      value={searchQuery}
      onChange={(evt) => updateQuery(evt.target.value)}
    />
    <table className="table">
      <thead>
        <tr>
          <th>Group Name</th>
          {survey.product_key === S.BEL4T ? (
            <th>Number of Teachers</th>
          ) : (
            <th>Number of Schools</th>
          )}
        </tr>
      </thead>
      <tbody>
        {groups.length ? (
          groups.map((t) => (
            <tr key={t.slug}>
              <TargetCell target={t} rankDisplay={false} />
              <td>{t.school_count}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="2">No groups available.</td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

let ClientLandingUI = connect(
  derivedProps,
  dispatchers,
)((props) => (
  <Tabs
    id="survey-tabs"
    justified={true}
    className={staticData.survey.wants_groups_tab ? "groups" : "no-groups"}
  >
    <Tab
      eventKey="schools"
      title={props.survey.product_key === S.BEL4T ? "Teachers" : "Schools"}
    >
      <SchoolsPanel {...props} />
    </Tab>
    {staticData.survey.wants_groups_tab ? (
      <Tab eventKey="groups" title="Groups">
        <GroupsPanel {...props} />
      </Tab>
    ) : null}
  </Tabs>
));

render(
  <ClientLandingUI store={store} />,
  document.querySelector("#react_target"),
);
